// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"486":"cb2cc348bce56ced","875":"3f89c8ee4a029e51"}[chunkId] + ".js";
};